import React from "react";
import styles from "../styles/ServicesPage.module.css";
import ServiceCard from "../components/ServiceCard";
import ProcessStep from "../components/ProcessStep";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CTASection from "../components/CTASection";

const ServicesPage = () => {
  return (<>
    <div className={styles.container}>
      <Navbar />
      {/* Header/Navigation */}

      {/* Hero Section */}
      <section className={`${styles.heroSection} section-container`}>
        <div className={styles.servicesBadge}>Our Services</div>
        <h1 className={styles.heroTitle}>
          Transforming Ideas into Digital Excellence
        </h1>
        <p className={styles.heroDescription}>
          From concept to deployment, we deliver comprehensive digital solutions
          that drive growth and exceed expectations.
        </p>
        <div className={styles.statsContainer}>
          <div className={styles.statCard}>
            <div className={styles.statNumber}>17+</div>
            <div className={styles.statLabel}>Projects Completed</div>
          </div>
          <div className={styles.statCard}>
            <div className={styles.statNumber}>98%</div>
            <div className={styles.statLabel}>Client Satisfaction</div>
          </div>
          <div className={styles.statCard}>
            <div className={styles.statNumber}>10+</div>
            <div className={styles.statLabel}>Expert Developers</div>
          </div>
        </div>
      </section>

      {/* Services Filter Section */}
      <section className={`${styles.servicesSection} section-container`}>
        <div className={styles.filterContainer}>
          <button className={styles.filterButton}>All</button>
          <button className={styles.filterButton}>Frontend</button>
          <button className={styles.filterButton}>Backend</button>
          <button className={styles.filterButton}>Mobile</button>
          <button className={styles.filterButton}>CMS</button>
        </div>
        <div className={styles.servicesGrid}>
          <ServiceCard
            title="Frontend Development"
            description="Building responsive and interactive UIs with modern frontend technologies"
            stats={[
              { number: "25+", label: "UI Components" },
              { number: "99%", label: "Client Satisfaction" },
            ]}
            technologies={[
              "Figma",
              "React JS",
              "HTML5",
              "Bootstrap",
              "Tailwind CSS",
              "JavaScript",
              "jQuery",
            ]}
          />
          <ServiceCard
            title="Backend Development"
            description="Server-side logic, database management, and API development"
            stats={[
              { number: "100+", label: "APIs Built" },
              { number: "97%", label: "System Uptime" },
            ]}
            technologies={[
              "Node JS",
              "Express JS",
              "PHP",
              "Laravel",
              "Java",
              "Spring Boot",
              "MySQL",
            ]}
          />
          <ServiceCard
            title="Mobile Development"
            description="Native and cross-platform mobile applications for iOS and Android"
            stats={[
              { number: "2", label: "Apps Delivered" },
              { number: "96%", label: "App Store Rating" },
            ]}
            technologies={["React Native", "Swift UI", "Kotlin"]}
          />
          <ServiceCard
            title="Content Management Systems (CMS)"
            description="Customizable and scalable CMS solutions for content-driven websites"
            stats={[
              { number: "10+", label: "Websites Launched" },
              { number: "95%", label: "Client Satisfaction" },
            ]}
            technologies={["WordPress", "Wix", "Shopify"]}
          />
        </div>
      </section>

      {/* Development Process Section */}
      <section className={`${styles.processSection} section-container`}>
        <div className={styles.processSectionHeader}>
          <h2 className={styles.processTitle}>Our Development Process</h2>
          <p className={styles.processDescription}>
            We follow a systematic approach to deliver high-quality solutions
            that meet your business objectives.
          </p>
        </div>
        <div className={styles.processStepsGrid}>
          <ProcessStep
            number="1"
            title="Discovery"
            description="Understanding your requirements and business goals"
            isHighlighted={true}
          />
          <ProcessStep
            number="2"
            title="Planning"
            description="Creating detailed project roadmap and architecture"
          />
          <ProcessStep
            number="3"
            title="Development"
            description="Building your solution with best practices"
          />
          <ProcessStep
            number="4"
            title="Launch"
            description="Deploying and maintaining your application"
          />
        </div>
      </section>

      {/* CTA Section */}
      <section className="" style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>

      <CTASection />
      </section>


      {/* Updated Pricing Section */}
      <section className={`${styles.pricingSection} section-container`}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Transparent Pricing</h2>
          <p className={styles.sectionSubtitle}>Choose the perfect plan for your digital transformation</p>
        </div>
        
        <div className={styles.pricingGrid}>
          {/* Starter Plan */}
          <div className={`${styles.pricingCard} ${styles.starterCard}`}>
            <div className={styles.cardHeader}>
              <h3 className={styles.planName}>Starter</h3>
              <div className={styles.priceContainer}>
                <span className={styles.priceCurrency}>₹</span>
                <span className={styles.price}>25,000</span>
              </div>
              <p className={styles.planDescription}>Perfect for small businesses and landing pages</p>
            </div>
            <ul className={styles.planFeatures}>
              <li><span className={styles.featureIcon}>✓</span> Up to 2-page website</li>
              <li><span className={styles.featureIcon}>✓</span> Basic UI/UX design</li>
              <li><span className={styles.featureIcon}>✓</span> Responsive layout</li>
              <li className={styles.featureDisabled}>SEO optimization</li>
              <li className={styles.featureDisabled}>CMS integration</li>
            </ul>
            <button className={`${styles.ctaButton} ${styles.starterButton}`}>Get Started</button>
          </div>

          {/* Popular Growth Plan */}
          <div className={`${styles.pricingCard} ${styles.popularCard}`}>
            <div className={styles.popularBadge}>MOST POPULAR</div>
            <div className={styles.cardHeader}>
              <h3 className={styles.planName}>Growth</h3>
              <div className={styles.priceContainer}>
                <span className={styles.priceCurrency}>₹</span>
                <span className={styles.price}>50,000</span>
              </div>
              <p className={styles.planDescription}>Ideal for growing businesses and web apps</p>
            </div>
            <ul className={styles.planFeatures}>
              <li><span className={styles.featureIcon}>✓</span> Up to 5-page website</li>
              <li><span className={styles.featureIcon}>✓</span> Advanced UI/UX design</li>
              <li><span className={styles.featureIcon}>✓</span> CMS integration</li>
              <li><span className={styles.featureIcon}>✓</span> Basic SEO optimization</li>
              <li><span className={styles.featureIcon}>✓</span> Contact form integration</li>
            </ul>
            <button className={`${styles.ctaButton} ${styles.popularButton}`}>Choose Growth</button>
          </div>

          {/* Enterprise Plan */}
          <div className={`${styles.pricingCard} ${styles.enterpriseCard}`}>
            <div className={styles.cardHeader}>
              <h3 className={styles.planName}>Enterprise</h3>
              <div className={styles.priceContainer}>
                <span className={styles.priceCurrency}>₹</span>
                <span className={styles.price}>100,000+</span>
              </div>
              <p className={styles.planDescription}>Custom solutions for complex requirements</p>
            </div>
            <ul className={styles.planFeatures}>
              <li><span className={styles.featureIcon}>✓</span> Full-stack web/mobile solution</li>
              <li><span className={styles.featureIcon}>✓</span> Custom integrations</li>
              <li><span className={styles.featureIcon}>✓</span> Dedicated support</li>
              <li><span className={styles.featureIcon}>✓</span> Advanced SEO</li>
              <li><span className={styles.featureIcon}>✓</span> Ongoing maintenance</li>
            </ul>
            <button className={`${styles.ctaButton} ${styles.enterpriseButton}`}>Contact Us</button>
          </div>
        </div>
        
        <div className={styles.customSolution}>
          <p>Need a custom solution? <a href="#contact">Get a personalized quote →</a></p>
        </div>
      </section>

      {/* Updated Project Plans Section */}
      <section className={`${styles.plansSection} section-container`}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Our Development Journey</h2>
          <p className={styles.sectionSubtitle}>Transparent process from concept to launch</p>
        </div>
        
        <div className={styles.timelineContainer}>
          <div className={styles.timeline}>
            {/* Phase 1 */}
            <div className={styles.timelineItem}>
              <div className={styles.timelineDot}></div>
              <div className={styles.timelineContent}>
                <div className={styles.phaseBadge}>Phase 1</div>
                <h4 className={styles.stepTitle}>Discovery & Strategy</h4>
                <p className={styles.stepDetail}>1 week – Detailed requirements analysis and scope definition</p>
                <div className={styles.phaseFeatures}>
                  <span>Stakeholder interviews</span>
                  <span>Competitor analysis</span>
                  <span>Project roadmap</span>
                </div>
              </div>
            </div>
            
            {/* Phase 2 */}
            <div className={styles.timelineItem}>
              <div className={styles.timelineDot}></div>
              <div className={styles.timelineContent}>
                <div className={styles.phaseBadge}>Phase 2</div>
                <h4 className={styles.stepTitle}>Design & Prototyping</h4>
                <p className={styles.stepDetail}>2 weeks – Wireframes, mockups and user flows</p>
                <div className={styles.phaseFeatures}>
                  <span>UX research</span>
                  <span>Interactive prototypes</span>
                  <span>Design system</span>
                </div>
              </div>
            </div>
            
            {/* Phase 3 */}
            <div className={styles.timelineItem}>
              <div className={styles.timelineDot}></div>
              <div className={styles.timelineContent}>
                <div className={styles.phaseBadge}>Phase 3</div>
                <h4 className={styles.stepTitle}>Development & Testing</h4>
                <p className={styles.stepDetail}>4–6 weeks – Agile development with continuous testing</p>
                <div className={styles.phaseFeatures}>
                  <span>Sprint planning</span>
                  <span>Code reviews</span>
                  <span>QA testing</span>
                </div>
              </div>
            </div>
            
            {/* Phase 4 */}
            <div className={styles.timelineItem}>
              <div className={styles.timelineDot}></div>
              <div className={styles.timelineContent}>
                <div className={styles.phaseBadge}>Phase 4</div>
                <h4 className={styles.stepTitle}>Launch & Optimization</h4>
                <p className={styles.stepDetail}>1 week – Deployment and performance monitoring</p>
                <div className={styles.phaseFeatures}>
                  <span>Deployment checklist</span>
                  <span>User training</span>
                  <span>Performance tuning</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className={styles.processNote}>
          <p>All timelines are estimates. Actual duration may vary based on project complexity.</p>
        </div>
      </section>

      <Footer />
    </div>
    </>
  );
};

export default ServicesPage;